import { graphql } from '@gql';

export const TabSectionCardSectionFragment = graphql(/* GraphQL */ `
  fragment TabSectionCardSectionFragment on VildarPageComponentsTabsSectionBlockTabCardSectionNode {
    ... on VildarCardSection {
      title
      display_title
      link {
        external_url {
          href
          title
        }
        internal_urlConnection {
          edges {
            node {
              ... on VildarPage {
                title
                navigation_title
                url
              }
            }
          }
          totalCount
        }
        label
      }
      card_template
      pagination
      paragraph
      post_limit
      sidebar
      type
      simple_boxes {
        ... on VildarCardSectionSimpleBoxesBox {
          __typename
          box {
            background_color
            headline
            text
          }
        }
      }
      persons {
        ... on VildarCardSectionPersonsPerson {
          __typename
          person {
            description
            name
          }
        }
      }
    }
  }
`);
export const TabsSectionFragment = graphql(/* GraphQL */ `
  fragment VildarTabSectionFragment on VildarPageComponentsTabsSection {
    ... on VildarPageComponentsTabsSection {
      __typename
      tabs_section {
        tab {
          title
          card_sectionConnection {
            edges {
              node {
                ...TabSectionCardSectionFragment
              }
            }
            totalCount
          }
        }
      }
    }
  }
`);
